import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Divider, Row, Avatar, Col, Card, Descriptions, Breadcrumb } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { UserOutlined } from '@ant-design/icons';
import { getEcole } from '../ecole/ecole.reducer';
import { getComptable } from './comptable-reducer';
import ComptableOptions from './options-comptable';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { getSession } from 'app/shared/reducers/authentication';
export const ComptableDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getComptable(props.match.params.id));
  }, []);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const comptable = useAppSelector(state => state.comptable.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );

  return (
    <>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/comptable/${currentEcole && currentEcole.id}`}>Comptables</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Row className=" justify-content-center">
          <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }} className="pt-4">
            <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} icon={<UserOutlined />} />
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
            <h2 style={{ textAlign: 'center' }} className="p-4">
              {' '}
              {comptable.firstName} {comptable.lastName}{' '}
            </h2>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Login">{comptable.login}</Descriptions.Item>
                <Descriptions.Item label="Email">{comptable.email}</Descriptions.Item>
                <Descriptions.Item label="Téléphone">{comptable.telephone}</Descriptions.Item>
                <Descriptions.Item label="Adresse">{comptable.adresse}</Descriptions.Item>
              </Descriptions>
            </span>
          </Col>
          {isNotComptable && isNotSurveillantGeneral && (
            <>
              <Divider type="vertical" style={{ height: 'auto' }} />
              <Col lg={{ span: 4 }} xs={{ span: 24 }} md={{ span: 8 }} sm={{ span: 8 }} style={{ textAlign: 'center' }}>
                <ComptableOptions {...props} />
              </Col>
            </>
          )}
        </Row>
      </Card>
    </>
  );
};
export default ComptableDetail;
